import { IMPERSONATION_BANNER_HEIGHT, useImpersonationSessions } from '@hooks/impersonation';
import useStoreAppConfig from '@hooks/useStoreAppConfig';
import { Stack } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

import { HotelChainSelector } from '../components/hotel-chain-selector/index.js';
import { HotelSelector } from '../components/hotel-selector/index.js';
import { COLLAPSED_WIDTH, EXPANDED_WIDTH } from '../nav-vertical/constants.js';

import { NotificationBell } from './notifications/index.js';
import { Topbar } from './Topbar.js';

export function Header() {
  const [{ sidebarCollapsed }] = useStoreAppConfig();
  const { isImpersonating } = useImpersonationSessions();
  const sidebarWidth = sidebarCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH;

  return (
    <AppBar
      elevation={0}
      position="fixed"
      sx={{
        bgcolor: isImpersonating ? 'error.lighter' : 'background.paper',
        color: isImpersonating ? 'error.darker' : 'text.primary',
        borderBottom: isImpersonating ? 2 : 1,
        borderColor: isImpersonating ? 'error.main' : 'divider',
        top: isImpersonating ? IMPERSONATION_BANNER_HEIGHT : 0,
        zIndex: (theme) => theme.zIndex.drawer - 1,
        left: sidebarWidth,
        width: `calc(100% - ${sidebarWidth}px)`,
        transition: 'left 0.2s ease, width 0.2s ease, top 0.2s ease',
      }}
    >
      <Toolbar sx={{ gap: 2, px: { sm: 3 } }}>
        <HotelSelector />
        <HotelChainSelector />

        <Stack alignItems="center" direction="row" sx={{ ml: 'auto' }}>
          <NotificationBell />
          <Topbar />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
